// src/components/loginpage/signupbox/regsuccess/Regsuccess.jsx
// Countdown logic and props unchanged. Markup rebuilt to the Modernist mockup:
// brand plate (also the way home), display-scale statement, two ruled action
// tiles instead of the SVG buttons, live countdown.
import React, { useEffect, useState } from "react";
import "./regsuccess.css";
import logoMark from "../../../../assets/images/logo-mark.png";

const RegSuccess = ({
  title = "Registration Successful",
  details = "Your account has been created. Check your email to verify and complete the setup.",
  controlMsg = "You can now proceed to login or return to the homepage.",
  onLogin = () => {},
  onHome = () => {},
  redirectSeconds = 10,
  onCountdownEnd,              // parent SPA toggle handler
  fallbackUrl = "/",           // used only if onCountdownEnd is not provided
}) => {
  const [secondsLeft, setSecondsLeft] = useState(redirectSeconds);

  useEffect(() => {
    const id = setInterval(() => {
      setSecondsLeft((s) => {
        if (s <= 1) {
          clearInterval(id);

          // Preferred SPA flow: let parent decide (e.g., unmount this component)
          if (typeof onCountdownEnd === "function") {
            onCountdownEnd();
          } else {
            // Safe fallback if no handler is passed
            if (window.history && window.history.length > 1) {
              window.history.back();
            } else {
              window.location.assign(fallbackUrl);
            }
          }

          return 0;
        }
        return s - 1;
      });
    }, 1000);

    return () => clearInterval(id);
  }, [onCountdownEnd, fallbackUrl]);

  return (
    <div className="rw-auth">
      <div className="rw-auth__top">
        <button type="button" className="rw-brand-plate" onClick={onHome} title="Back to Riftworks home">
          <img src={logoMark} alt="Riftworks" />
          <span>
            <strong>RIFTWORKS</strong>
            <em>
              <svg width="11" height="11" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <line x1="19" y1="12" x2="5" y2="12" />
                <polyline points="12 19 5 12 12 5" />
              </svg>
              Back to home
            </em>
          </span>
        </button>
      </div>

      <section className="rw-auth__body" role="region" aria-label="Registration success">
        <div className="rw-auth__kicker">
          <span className="rw-auth__badge" aria-hidden="true">
            <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
              <polyline points="20 6 9 17 4 12" />
            </svg>
          </span>
          <span>Step 2 of 2 · Account created</span>
        </div>

        <h1 className="rw-auth__title">{title}</h1>
        <p className="rw-auth__lede">{details}</p>
        <p className="rw-auth__note">{controlMsg}</p>

        <div className="rw-auth__actions">
          <button
            type="button"
            className="rw-auth__tile"
            onClick={onLogin}
            aria-label="Login"
          >
            <span className="rw-auth__tile-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M15 3h4a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2h-4" />
                <polyline points="10 17 15 12 10 7" />
                <line x1="15" y1="12" x2="3" y2="12" />
              </svg>
            </span>
            <span>
              <strong>Login</strong>
              <em>Sign in with your new account</em>
            </span>
          </button>

          <button
            type="button"
            className="rw-auth__tile"
            onClick={onHome}
            aria-label="Home"
          >
            <span className="rw-auth__tile-icon" aria-hidden="true">
              <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 10.5 12 3l9 7.5" />
                <path d="M5 9.8V21h14V9.8" />
              </svg>
            </span>
            <span>
              <strong>Home</strong>
              <em>Back to riftworks.tech</em>
            </span>
          </button>
        </div>

        <div className="rw-auth__countdown" aria-live="polite">
          <span className="rw-auth__dash" aria-hidden="true" />
          Returning to the main page in <strong>{secondsLeft}</strong> second
          {secondsLeft === 1 ? "" : "s"}…
        </div>
      </section>

      <div className="rw-auth__foot">Riftworks · RW Login Central v 1.1.2</div>
    </div>
  );
};

export default RegSuccess;
